import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axiosClient, { getData } from '.././global/Globalapi'
import { encodeId } from '../global/Globalfunction';

const ProductCard = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [mainImage, setMainImage] = useState('');
   const baseURL = axiosClient.defaults.baseURL

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const res = await getData(`/product/${id}`);
        setProduct(res.data);

        if (res.data.images && res.data.images.length > 0) {
          setMainImage(`${baseURL}/uploads/${res.data.images[0].file_name}`);
        } else {
          setMainImage("https://via.placeholder.com/300x200?text=No+Image");
        }
      } catch (err) {
        console.error("Failed to fetch product:", err);
      }
    };

    fetchProduct();
  }, [id]);

  if (!product) return <div className="text-center p-8">Loading...</div>;

  const thumbnails = product.images?.map(img => `${baseURL}/uploads/${img.file_name}`) || [];

  return (
    <div className="w-full h-screen">
  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 border rounded-xl shadow-lg p-4 bg-white h-full">
        {/* Image Section */}
        <div className="flex">
          <div className="flex flex-col space-y-2 mr-2 w-16">
            {thumbnails.map((src, index) => (
              <img
                key={index}
                src={src}
                alt={`Thumbnail ${index + 1}`}
                className={`h-[50px] object-cover rounded border cursor-pointer ${
                  src === mainImage ? "border-blue-600 ring-2 ring-blue-400" : "border-gray-300"
                } hover:scale-105 transition-all duration-150`}
                onClick={() => setMainImage(src)}
              />
            ))}
          </div>
          <div className="flex-grow text-center">
            <img
              src={mainImage}
              alt="Main"
              className="max-h-[500px] mx-auto object-contain transition-opacity duration-500"
            />
          </div>
        </div>

        {/* Info Section */}
        <div className="md:col-span-2 flex flex-col justify-between">
          <div>
            <h2 className="text-2xl font-bold mb-2">{product.product_name}</h2>

            <p className="text-sm text-gray-600 mb-1">
              Price: <span className="font-medium">{product.initial_stock}</span>
            </p>
            <p className="text-sm text-gray-600 mb-4">
              MRP Price: <span className="font-medium">₹{product.mrp_price}</span>
            </p>

            {/* Size Grid */}
            {product.components && product.components.length > 0 && (
              <div className="mt-6">
                <h3 className="text-lg font-semibold mb-2">Available Sizes</h3>
                <div className="flex flex-wrap gap-3">
                  {product.components
                    .filter(comp => comp.attribute_name === "Size")
                    .map((comp, idx) => (
                      <div
                        key={idx}
                        className="border rounded-lg px-4 py-2 text-center w-20 hover:shadow transition duration-200"
                      >
                        <div className="text-sm font-medium">{comp.comp_value}</div>
                        <p className="text-sm text-gray-700"><span className="font-medium">{product.initial_stock}</span></p>
                      <p className="text-sm text-gray-700">₹<span className="font-medium">{product.mrp_price}</span></p>
                      </div>
                    ))}
                </div>
              </div>
            )}

            {/* Components / Features (Other than Size) */}
            {product.components &&
              product.components.some(comp => comp.attribute_name !== "Size") && (
                <div className="mt-6">
                 
                  <ul className="list-disc list-inside text-gray-700">
                    {product.components
                      .filter(comp => comp.attribute_name !== "Size")
                      .map((comp, idx) => (
                        <li key={idx} className="mb-1">
                          <span className="text-gray-900 font-medium">{comp.attribute_name}</span>:{" "}
                          <span className="text-gray-600">{comp.comp_value}</span>
                        </li>
                      ))}
                  </ul>
                </div>
              )}
          </div>

          {/* Action */}
          <div className="mt-4">
            <button className="bg-yellow-400 hover:bg-yellow-500 text-black font-semibold px-4 py-2 rounded mr-2">
              Add to Cart
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
